export const getLocalStorageKey = tableId => tableId + '_Columns'

export const getColumnVisibility = i => {
  const isNew = i === undefined
  const isVisible = i === true

  return !!(isNew || isVisible)
}
